/* JWL CART — free-shipping progress track. Rationale: docs/jwl-cart-build.md -> "JS notes" */
(function () {
  function ensureParts(el) {
    var message = el.querySelector('.jwl-shipping-message');
    if (!message) {
      message = document.createElement('div');
      message.className = 'jwl-shipping-message';
      el.insertBefore(message, el.firstChild);
    }

    /* icon + theme placeholder start as direct children; order matters — see docs */
    var icon = el.querySelector('.jwl-shipping-row__icon');
    if (icon && icon.parentElement !== message) {
      message.insertBefore(icon, message.firstChild);
    }

    var placeholder = el.querySelector('.text-subdued');
    if (placeholder && placeholder.parentElement !== message) {
      message.appendChild(placeholder);
    }

    var track = el.querySelector('.jwl-shipping-track');
    if (!track) {
      track = document.createElement('div');
      track.className = 'jwl-shipping-track';
      track.appendChild(document.createElement('span'));
      el.insertBefore(track, message.nextSibling);
    }

    /* track-end icon moved once; position is pure CSS — see docs */
    var trackIcon = el.querySelector('.jwl-shipping-track__icon');
    if (trackIcon && trackIcon.parentElement !== track) {
      track.appendChild(trackIcon);
    }

    return track;
  }

  function update(el) {
    var track = ensureParts(el);
    var fill = track.querySelector('span');
    var threshold = parseFloat(el.getAttribute('threshold')) || 0;
    var total = parseFloat(el.getAttribute('total-price')) || 0;
    var qualified = threshold > 0 && total >= threshold;
    var pct = threshold > 0 ? Math.min(100, (total / threshold) * 100) : 100;
    fill.style.width = pct + '%';
    track.classList.toggle('jwl-shipping-track--qualified', qualified);
  }

  function scan() {
    document.querySelectorAll('free-shipping-bar').forEach(update);
  }

  function start() {
    scan();
    new MutationObserver(scan).observe(document.body, {
      childList: true,
      subtree: true,
      attributes: true,
      attributeFilter: ['total-price', 'threshold'],
    });
  }

  if (document.body) {
    start();
  } else {
    document.addEventListener('DOMContentLoaded', start);
  }
})();
